import clsx from 'clsx';
import { useState, useEffect } from 'react';
import HeaderBlackBand from 'components/layouts/header-blackband';
import useRouter from 'hooks/use-router';
import { LayoutProps } from './layouts-interfaces';
import FooterBlackBand from './footer/footer-black-band';

export default function MaleDefaultLayout(props: LayoutProps) {
  const { children, timeToComplete } = props;
  const { pathname } = useRouter();
  const isHeaderSticky = pathname.includes('/results');
  const showProgressBar = pathname.includes('/hormone-assessment');
  const [scrollProgress, setScrollProgress] = useState(0);

    useEffect(() => {
     if (!showProgressBar) {
       return () => {
          document.body.style.paddingTop = '0';
      };
    }
    // padding equal to header height
    const header = document.querySelector('header');
    if (header) {
      const headerHeight = header.offsetHeight;
      document.body.style.paddingTop = `${headerHeight}px`;
    }
    const handleScroll = () => {
      // how far down the page has been scrolled
      const scrollTop = window.scrollY;
      // total scrollable height (total document height minus viewport height)
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      // progress percentage
      const progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 0;
      setScrollProgress(progress);
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.style.paddingTop = '0';
    };
  }, [showProgressBar]);

  return (
    <div className='flex min-h-screen flex-col content-around items-center bg-tan-grey'>
      <header className={clsx(
              `header-bottom-border w-full border-b-[1px] bg-blackband px-2 ${isHeaderSticky ? 'fixed top-0 left-0 z-20' : ''}`,
              {
                'fixed top-0 left-0 right-0 z-20': showProgressBar,
              }
            )}
      >
        <HeaderBlackBand
          timeToComplete={timeToComplete}
          isSecureCheckout={pathname.includes('/payment')}
          showProgressBar={false}
        />
        {showProgressBar && (
        <div className="block md:hidden absolute -bottom-[5px] left-0 w-full h-[5px] bg-transparent">
          <div
            className="h-full bg-gradient-to-r from-[#9D1C1F] to-[#9D1C1F]"
            style={{ width: `${scrollProgress}%`, transition: 'width 0.1s' }}
          />
        </div>
        )}
      </header>
      <div className='my-4 min-h-[calc(100vh-10rem)] content-top p-0 md:my-5'>
        {children}
      </div>
      <FooterBlackBand />
    </div>
  );
}
